import TypeSkeleton from "./form-fields/TypeSkeleton";

const FormSkeleton = ({ n = 5 }) => {
  return Array(n).fill(<TypeSkeleton />);
};

export default FormSkeleton;
